import * as React from 'react';

const MOBILE_BREAKPOINT = 768;

export function useIsMobile(): boolean | undefined {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = globalThis.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = (): void => {
      setIsMobile(globalThis.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener('change', onChange);
    setIsMobile(globalThis.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  // Return undefined initially, true/false after detection
  return isMobile;
}

// Tablet-or-below helper (<= 1023px)
const TABLET_BREAKPOINT = 1024;
export function useIsTabletOrBelow(): boolean {
  // FIXED: Initialize with actual device check instead of undefined
  const [isTabletOrBelow, setIsTabletOrBelow] = React.useState<boolean>(() => {
    // Check if we're in browser environment
    if (typeof window !== 'undefined') {
      return window.innerWidth < TABLET_BREAKPOINT;
    }
    // Default to true for SSR to avoid desktop restrictions on mobile
    return true;
  });

  React.useEffect(() => {
    const mql = globalThis.matchMedia(`(max-width: ${TABLET_BREAKPOINT - 1}px)`);
    const onChange = (): void => {
      setIsTabletOrBelow(globalThis.innerWidth < TABLET_BREAKPOINT);
    };
    mql.addEventListener('change', onChange);
    // Set initial value
    setIsTabletOrBelow(globalThis.innerWidth < TABLET_BREAKPOINT);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isTabletOrBelow;
}
